import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@assets/images/activity/nft-img-icon.png';
const _withScopeId = n => (_pushScopeId("data-v-35b98ecd"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "seq-box"
};
const _hoisted_2 = {
  class: "img-title"
};
const _hoisted_3 = {
  class: "seq-title render-line-clamp"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createBlock(_component_van_popup, {
    class: "seq",
    show: $options.show,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $options.show = $event),
    onOpen: $options.open
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("i", {
      class: "seq-close",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.closePicker && $options.closePicker(...args))
    }), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
      class: "img-info",
      style: _normalizeStyle(`background-image: url(${_ctx.$imgUrlFilter($props.seq_url, 200)})`)
    }, null, 4)]), _createElementVNode("div", _hoisted_3, _toDisplayString($props.seq_tit), 1)]), _createElementVNode("div", {
      class: _normalizeClass(['seq-list', `seq-list-${$props.seq_list.length % 3}`])
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.seq_list, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(['seq-item', {
          'is-check': $data.seq_item.stock_hash == item.stock_hash
        }]),
        onClick: $event => $options.checkSeq(item)
      }, [_hoisted_5, _createElementVNode("span", null, _toDisplayString(item.seq), 1)], 10, _hoisted_4);
    }), 128))], 2), _createElementVNode("div", {
      class: "seq-add-btn",
      onClick: _cache[1] || (_cache[1] = (...args) => $options.getCheckSeq && $options.getCheckSeq(...args))
    }, "确认")])]),
    _: 1
  }, 8, ["show", "onOpen"]);
}